export default __webpack_public_path__ + "static/media/drip2.f0b74268.jpeg";